<template>
  <v-navigation-drawer
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    :value="drawer"
    @input="$emit('input', $event)">
    <v-list nav>
      <v-list-item :to="{ name: 'processing' }">
        <v-list-item-icon>
          <v-icon>$vuetify.icons.boxCheck</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.navigation.orders') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'orders' }">
        <v-list-item-icon>
          <v-icon>$vuetify.icons.orders</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Objednávky
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'shipments' }">
        <v-list-item-icon>
          <v-icon>$vuetify.icons.fileImport</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.navigation.packetaShipments') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'files.history' }">
        <v-list-item-icon class="ml-1">
          <v-icon>$vuetify.icons.ballotCheck</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.navigation.checkedFiles') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
